import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SwitchStyles from './switchStyles';

const Switch = props => {
  const [isActiveState, setState] = useState(props.isActive);

  const handleChange = () => {
    setState(!isActiveState);
    console.log(`isActiveState: ${isActiveState}`);
  };

  return <SwitchStyles isActive={isActiveState} onClick={handleChange}>{` `}</SwitchStyles>;
};

Switch.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

export default Switch;
